<nav class="nav mat-tab-nav-bar-sm"
     [tabPanel]="tabPanel"
     mat-tab-nav-bar
     backgroundColor="transparent-white"
     mat-stretch-tabs="false">
  <a mat-tab-link
     *ngFor="let tab of tabs"
     [routerLink]="tab.url"
     [queryParams]="tab.query"
     routerLinkActive
     #rla="routerLinkActive"
     [routerLinkActiveOptions]="{
      paths: 'exact',
      queryParams: 'ignored',
      fragment: 'ignored',
      matrixParams: 'ignored'
    }"
     [active]="rla.isActive">
    {{tab.label}}
  </a>
</nav>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
